module.exports = __webpack_public_path__ + "static/img/企业logo6.9f54ead4.jpeg";